import 'cally';
import { createApp, reactive } from 'petite-vue';
import gsap from 'gsap';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default () => {
  const { Mews } = window;

  const bookingData = reactive({
    hotelID: '',
    mewsInstance: null,
    destroyInstance() {
      if (this.mewsInstance) {
        this.mewsInstance = null;
        this.mewsInitialized = false;
        console.log('Mews instance destroyed');
      }
    },
    runMews(configuration) {
      this.destroyInstance();
      Mews.Distributor(
        {
          configurationIds: configuration.configurationIds,
          // openElements: '.booking_book-button',
        },
        (api) => {
          this.mewsInstance = api;
          console.log('Mews Distributor callback executed with configuration:', this.mewsInstance);
          // you can call API functions on a booking engine instance here
          // set different start and end date

          const setBookingParameters = () => {
            this.mewsInstance.setStartDate(configuration.startDate);
            this.mewsInstance.setEndDate(configuration.endDate);
            if (configuration.voucherCode) {
              this.mewsInstance.setVoucherCode(configuration.voucherCode);
            }

            if (configuration.roomID) {
              this.mewsInstance.showRates(configuration.roomID);
              this.mewsInstance.open();

              console.log('Room ID vorhanden, zeige Raten an und öffne Buchungsengine');

              return;
            }
            if (configuration.hotelID !== '') {
              this.mewsInstance.showRooms(configuration.hotelID);
              this.mewsInstance.open();

              console.log('Hotel ID vorhanden, zeige Zimmer an und öffne Buchungsengine');
            }
          };

          //   const openButton = document.querySelector('.booking_book-button');
          //   console.log('Open button:', openButton);
          //   openButton.addEventListener('click', () => {
          //     console.log('Booking button clicked');
          //     if (configuration.allowsBooking) {
          //       setBookingParameters();
          //     }
          //   });

          // For first time opening the booking engine, we want to show the rooms immediately
          if (configuration.allowsBooking) {
            setBookingParameters();
          }

          return true;
        }
      );
    },
  });

  const hideStartCalender = (event) => {
    const calendar = document.querySelector('[component="floating-calendar-1"]');

    if (!event) {
      gsap.to(calendar, { autoAlpha: 0, duration: 0.2 });
      return;
    }

    if (
      !event.target.classList.contains('booking_input') &&
      !event.target.classList.contains('booking_calender-month') &&
      !event.target.classList.contains('booking_calender') &&
      !event.target.classList.contains('booking_previous-next-btn') &&
      !event.target.classList.contains('booking_prev-next-icon') &&
      !event.target.classList.contains('lucide')
    ) {
      gsap.to(calendar, { autoAlpha: 0, duration: 0.2 });
    }
  };

  const hideEndCalender = (event) => {
    const calendar = document.querySelector('[component="floating-calendar-2"]');

    if (!event) {
      gsap.to(calendar, { autoAlpha: 0, duration: 0.2 });
      return;
    }

    if (
      !event.target.classList.contains('booking_input') &&
      !event.target.classList.contains('booking_calender-month') &&
      !event.target.classList.contains('booking_calender') &&
      !event.target.classList.contains('booking_previous-next-btn') &&
      !event.target.classList.contains('booking_prev-next-icon') &&
      !event.target.classList.contains('lucide')
    ) {
      gsap.to(calendar, { autoAlpha: 0, duration: 0.2 });
    }
  };

  document.body.addEventListener('click', hideStartCalender, true);
  document.body.addEventListener('click', hideEndCalender, true);

  function RoomCard() {
    return {
      rootElement: null,
      ctaBtnElement: null,
      clickTest() {
        this.bookingData.runMews({
          configurationIds: [bookingData.hotelID],
          openElements: '.booking_book-button',
          startDate: new Date(),
          endDate: new Date(),
          allowsBooking: true,
          roomID: this.rootElement.parentElement.dataset.roomId,
        });
      },
      mounted() {
        this.rootElement = this.$refs.carditem.closest('[component="card"]');
        this.ctaBtnElement = this.rootElement.querySelector('[child="link"]');

        if (this.ctaBtnElement) {
          this.ctaBtnElement.addEventListener('click', this.clickTest);
        } else {
          console.warn('CTA Button element not found');
        }
      },
    };
  }

  createApp({
    RoomCard,
    bookingData,
  }).mount('[component="room-card-list"]');

  createApp({
    bookingData,
    // hotelID: '',
    voucherCode: '',
    startDate: { display: 'Ankunft auswählen', value: new Date().toISOString().split('T')[0] },
    endDate: { display: 'Abreise auswählen', value: '' },
    tippyInstance: null,
    hotelPicker: { display: 'Hotel auswählen', value: '' },
    mewsInitialized: false,
    showPopupTriggerSpinner: false,

    get allowsBooking() {
      if (
        this.startDate.value &&
        this.endDate.value &&
        this.startDate.display !== 'Ankunft auswählen' &&
        this.endDate.display !== 'Abreise auswählen'
      ) {
        return true;
      }

      return false;
    },

    get minStartDate() {
      return new Date().toISOString().split('T')[0];
    },

    get minEndDate() {
      if (this.startDate.value) {
        const minEndDate = new Date(this.startDate.value);
        minEndDate.setDate(minEndDate.getDate() + 1);
        return minEndDate.toISOString().split('T')[0];
      }
      return new Date().toISOString().split('T')[0];
    },

    getHotelID() {
      const bookingElement = document.querySelector('[component="booking"]');

      if (bookingElement.dataset.hotelId) {
        bookingData.hotelID = bookingElement.dataset.hotelId;
      }
    },

    changeHotelID(linkElement) {
      console.log('Hotel ID geändert:', linkElement.dataset.hotelId);
      bookingData.hotelID = linkElement.dataset.hotelId;
      this.hotelPicker = { display: linkElement.textContent, value: linkElement.dataset.hotelId };
      document
        .querySelector('.booking_dropdown.w-dropdown')
        .dispatchEvent(new CustomEvent('w-close'));
    },

    getVoucherCode() {
      const searchParams = new URLSearchParams(window.location.search);
      this.voucherCode = searchParams.get('voucherCode');
    },

    initTippy() {
      const instance = tippy('.booking_book-button', {
        content: 'Bitte geben Sie Anreise- und Abreisedatum an, um eine Buchung vorzunehmen.',
      });

      this.tippyInstance = instance[0];
    },

    toggleTippy() {
      if (this.allowsBooking) {
        this.tippyInstance.disable();
      } else {
        this.tippyInstance.enable();
      }
    },

    initMews() {
      if (this.allowsBooking && this.mewsInitialized === false) {
        this.showPopupTriggerSpinner = true;
      }
      // const configurationIds = [];

      this.getHotelID();
      // configurationIds.push(this.hotelID);

      const configuration = {
        configurationIds: [bookingData.hotelID],
        openElements: '.booking_book-button',
        startDate: this.startDate.value ? new Date(this.startDate.value) : new Date(),
        endDate: this.endDate.value ? new Date(this.endDate.value) : new Date(),
        voucherCode: this.voucherCode,
        hotelID: bookingData.hotelID,
        allowsBooking: this.allowsBooking,
      };

      const mewsInstance = this.bookingData.runMews(configuration);

      setTimeout(() => {
        this.mewsInitialized = true;
        this.showPopupTriggerSpinner = false;
      }, 1000);

      if (this.mewsInitialized === false) {
        // Mews.Distributor(
        //   {
        //     configurationIds,
        //     // openElements: '.booking_book-button',
        //   },
        //   (api) => {
        //     // you can call API functions on a booking engine instance here
        //     // set different start and end date
        //     this.mewsInitialized = true;
        //     const setBookingParameters = () => {
        //       api.setStartDate(this.startDate.value ? new Date(this.startDate.value) : new Date());
        //       api.setEndDate(this.endDate.value ? new Date(this.endDate.value) : new Date());
        //       if (this.voucherCode) {
        //         api.setVoucherCode(this.voucherCode);
        //       }
        //       if (this.hotelID !== '') {
        //         api.showRooms(this.hotelID);
        //         api.open();
        //       }
        //     };
        //     // For first time opening the booking engine, we want to show the rooms immediately
        //     if (this.allowsBooking) {
        //       this.showPopupTriggerSpinner = false;
        //       setBookingParameters();
        //     }
        //     const openButton = document.querySelector('.booking_book-button');
        //     openButton.addEventListener('click', () => {
        //       if (this.allowsBooking) {
        //         setBookingParameters();
        //       }
        //     });
        //   }
        // );
      }
    },

    displayStartCalendar() {
      hideEndCalender();
      const calendar = document.querySelector('[component="floating-calendar-1"]');
      gsap.to(calendar, { autoAlpha: 1, duration: 0.5 });
    },
    displayEndCalendar() {
      hideStartCalender();
      const calendar = document.querySelector('[component="floating-calendar-2"]');
      gsap.to(calendar, { autoAlpha: 1, duration: 0.5 });
    },
    getDate() {
      const startCalendar = document.querySelector('[component="floating-calendar-1"]');
      const endCalendar = document.querySelector('[component="floating-calendar-2"]');

      endCalendar.addEventListener('change', (event) => {
        const selectedDate = event.target.value;
        const formattedDate = new Date(selectedDate).toLocaleDateString('de-DE');

        this.endDate = {
          display: formattedDate,
          value: new Date(selectedDate).toISOString().split('T')[0],
        };
        hideEndCalender();
        this.toggleTippy();
      });

      startCalendar.addEventListener('change', (event) => {
        const selectedDate = event.target.value;
        const formattedDate = new Date(selectedDate).toLocaleDateString('de-DE');

        this.startDate = {
          display: formattedDate,
          value: new Date(selectedDate).toISOString().split('T')[0],
        };
        this.endDate = { display: 'Abreise auswählen', value: '' };
        hideStartCalender();
        this.toggleTippy();
      });
    },
  }).mount('[component="booking"]');
};
